// types
import { ButtonProps, ButtonType } from './types';

// components
import Button from './button';

export default function ButtonPrimary({
  className,
  text = '',
  disabled,
  icon,
  type = ButtonType.BUTTON,
  size,
  onClick,
  bold,
  tabIndex,
}: ButtonProps): React.JSX.Element {
  return (
    <Button
      className={`${className || ''} primary`}
      text={text}
      size={size}
      disabled={disabled}
      icon={icon}
      type={type}
      onClick={onClick}
      bold={bold}
      tabIndex={tabIndex}
    />
  );
}
